import axios, { type AxiosRequestConfig, type AxiosResponse } from "axios";

type HTTP_ACCESS_METHODS = "GET" | "PUT" | "POST" | "DELETE" | "PATCH" | "OPTIONS";

type BaseApiParams = AxiosRequestConfig & {
    url: string;
    method: HTTP_ACCESS_METHODS;
    data?: any;     // for POST, PUT, etc requests
    params?: any;   // for GET requests
    headers?: any;
    isAuth?: boolean;
};

export type ApiParams = BaseApiParams & {
    [key: string]: any;
};

const axiosBaseRequest = axios.create({
    baseURL: `${import.meta.env.VITE_API_HOST}/api`
});

export const request = async <T>({ url, method, data, params, headers, isAuth, ...options }: ApiParams): Promise<AxiosResponse<T>> => {
    const authToken = localStorage.getItem("_t")?.replace(/["']/g, "");
    const headersParams = {
        region: import.meta.env.VITE_REGION,
        ...headers
    }

    axiosBaseRequest.defaults.headers = {
        ...(authToken && { Authorization: `Bearer ${authToken}` }),
        ...headersParams
    };

    return new Promise((resolve, reject) => {
        axiosBaseRequest({
            url,
            method,
            params,
            data,
            ...options
        })
            .then(response => resolve(response))
            .catch(error => reject(error));
    });
};
